import _ from 'lodash'
import {
    FETCH_RADAR_SUCCESS,
    UPDATE_TIMERANGE_SUCCESS,
    REFETCH_DATA_SUCCESS,
    UPDATE_TIMELINE,
    UPDATE_TIMELINES,
    REMOVE_TIMELINE_SUCCESS,
    ADD_TIMERANGE_SUCCESS
} from './actionTypes'

const normalizedTimeBoundaries = timelines => {
    if (timelines.length > 1) {
        return _.sortBy(timelines).map((timeline, index) => ({
            position: (1 / (timelines.length - 1)) * index,
            ...timeline
        }))
    }

    if (timelines.length === 1) {
        return [{ year: 0, position: 1 }, ...timelines]
    }

    return [0, 1]
}


const initialState = []

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case REFETCH_DATA_SUCCESS:
            return normalizedTimeBoundaries(payload.time_ranges)
        case FETCH_RADAR_SUCCESS:
            return normalizedTimeBoundaries(payload.time_ranges)
        case UPDATE_TIMERANGE_SUCCESS:
            return state.map(timeline => {
                if (timeline.id === payload.id) {
                    return payload
                }
                return timeline
            })
        case UPDATE_TIMELINES:
            return payload
        case REMOVE_TIMELINE_SUCCESS:
            return state.filter(({ id }) => id !== payload)
        case ADD_TIMERANGE_SUCCESS:
            return payload
        default:
            return state
    }
}
